// extracted by mini-css-extract-plugin
export var root = "layout-module--root--yUoiU";
export var main = "layout-module--main--Pw-Zk";